import {type Theme} from './Theme';
export type {Theme};

/**
 * Legacy themes
 */
export {default as designerTheme} from './designer';
export {default as adminTheme} from './admin';

/**
 * Legacy styled.
 */
export {ThemeContext, useTheme, themeable} from './LegacyThemeContext';
export type {PropsWithTheme} from './LegacyThemeContext';
export {styled, styledDiv} from './legacy';

/**
 * Z-indices
 */
export * as Z_INDEXES from './zindex';

/**
 * Emotion
 */
export {
  // Emotion
  cache,
  css,
  cx,
  emotionStyled,
  injectGlobal,
  keyframes,
  styleAtom,
  getSystemStyles,
  systemConfig,
  systemPseudoSelectors,
  baseScrollbarStyles,
} from './emotion';
export type {
  AnyComponent,
  StyleObject,
  BreakpointPropFor,
  RestrictiveScaleTypes,
  ScaleTypes,
  StyledComponentType,
} from './emotion';

export {SizeContext} from './SizeContext';
export {ThemeProvider, useThemeContext} from './ThemeContext';

/**
 * (Spring) Theming
 */
export {
  boxShadows,
  breakpoints,
  breakpointMaxWidth,
  breakpointMinWidth,
  colors,
  controls,
  coreColors,
  coreColorTokens,
  darkBrighterTheme,
  darkDarkerTheme,
  darkDefaultTheme,
  lightTheme,
  opacities,
  space,
  tokens,
  typography,
  coreColorVars,
  /**
   * These are used in Designer Extensions to pass theme values to Designer Apps and Extensions.
   */
  darkBrighterCSSVariables,
  darkDarkerCSSVariables,
  darkDefaultCSSVariables,
  lightCSSVariables,
} from '@packages/utilities/styled-tokens';
export type {
  SpringProviderUnits,
  ThemeColors,
} from '@packages/utilities/styled-tokens';

export type {ThemeProviderProps} from './ThemeContext';

export {
  animations,
  createMobileStyleAtom,
  mobileTextControlStyleAtom,
  customScrollbarAtom,
  fontSizeAtom,
  buttonResetAtom,
  reducedMotionAtom,
  hideOutlineAtom,
} from './__experiments';

/**
 * SizeContext
 */
export {useSizeContext, useSize, SizeContextProvider} from './SizeContext';
export type {SizeContextSizeValue} from './SizeContext';

/* Util exports */
export {forwardHtmlProps} from './utils';
export {createVars, createLegacyVars} from './createVars';

export {toHash, getDisplayName} from './utils';

import {injectRootVars} from './injectRootVars';

/**
 * Ensure that css-vars are available from :root.
 */
injectRootVars();
